var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0H3.75C1.67893 0 0 1.67893 0 3.75V12.25C0 14.3211 1.67893 16 3.75 16H12.25C14.3211 16 16 14.3211 16 12.25V3.75C16 1.67893 14.3211 0 12.25 0Z",
    fill: "#F4F2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60225 12.6899H4.59088V7.86036L1.75 5.72974V11.8377C1.75 12.3092 2.13213 12.6899 2.60225 12.6899Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4091 12.69H13.3977C13.8693 12.69 14.25 12.3079 14.25 11.8377V5.72974L11.4091 7.86042",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4091 4.16724V7.86042L14.25 5.7298V4.5933C14.25 3.53936 13.0469 2.93849 12.2046 3.57061",
    fill: "#FBBC04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59094 7.86036V4.16724L8 6.72393L11.4091 4.16711V7.8603L8 10.4172",
    fill: "#EA4335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.5933V5.72967L4.59088 7.86036V4.16724L3.79544 3.57061C2.95169 2.93849 1.75 3.53936 1.75 4.5933Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmailIcon.cd8e2ad8b6b9e0b98b9bb066384570fe.svg";
export { ForwardRef as ReactComponent };